import React from 'react';
import Link from 'gatsby-link';
import Imgix from 'react-imgix';
import Meta from '../components/Meta';
import { HomepageBanner } from '../components/Banners';
import VirtualTourAbstract from '../images/virtual-tour-abstract.jpg';
import FooterMap from '../components/FooterMap';
import { StatQuery, PageQueryAbstractPhoto } from '../components/HomeHelpers';
import {
  FeedQueryUp,
  FeedQueryDown,
  PageQueryBannerPhoto
} from '../components/PageHelpers';
import { findRecentEvents, findRecentStories } from '../util/helperFunctions';

const Home = ({ data }) => {
  const page = data.mortyPage;
  const block1 = page.childrenMortyBlock[0];
  const block2 = page.childrenMortyBlock[1];
  const featuredInterior = data.canalCruises.edges[0].node;
  const featuredEventsPage = data.featuredEventsPage.edges[0].node;
  const exploreDowntown = data.exploreDowntown.edges[0].node;
  const liveDowntown = data.liveDowntown.edges[0].node;
  const workDowntown = data.workDowntown.edges[0].node;
  const ourEvents = data.ourEvents.edges[0].node;
  const ourServices = data.ourServices.edges[0].node;
  const aboutUs = data.aboutUs.edges[0].node;
  const news = data.news.edges[0].node;
  const allNews = data.allNews ? data.allNews.edges.map(d => d.node) : null;
  const orderedNews = allNews ? findRecentStories(allNews) : null;
  const mostRecentNews = orderedNews ? orderedNews[0] : null;
  const ventureEvents = data.ventureEvents.edges.map(d => d.node);
  const orderedVentureEvents = findRecentEvents(ventureEvents);
  const mostRecentVentureEvent = orderedVentureEvents[0];

  return (
    <div className="home">
      <Meta page={page} />
      <div>

        <HomepageBanner page={page} exploreDowntown={exploreDowntown} />
        {/* Featured Interior Component */}
        <PageQueryBannerPhoto page={featuredInterior} />

        {mostRecentNews && (
          <FeedQueryUp
            page={mostRecentNews}
            className="mv3 mv5-l"
            secondaryLink={news}
          />
        )}


        {/* This is the downwtown RVA section */}
        <div className="flex flex-column items-center">
          <h3 className="p-emphasis p-lead-spaced--l dark mb0 ttu tc mh2 mw-696">
            Downtown RVA
          </h3>
          <h4
            className="p-emphasis p-lead-spaced--l grey1 mb0 ttu tc mh2 mw-696"
            dangerouslySetInnerHTML={{ __html: block1.content }}
          />
          {/* Statistic Components */}
          <div className="flex flex-column flex-row-l justify-between-l w-100 mw-1060 mt2-l mb3 mb5-l">
            <StatQuery page={exploreDowntown} className="bg-blue" />
            <StatQuery page={liveDowntown} className="bg-green mt1 mt0-l" />
            <StatQuery page={workDowntown} className="bg-brick mt1 mt0-l" />
          </div>
        </div>
        {/* Our Mission Section */}
        <div className="flex flex-column items-center bg-stone pv3 pv5-l">
          <h3 className="p-emphasis p-lead-spaced--l dark mb0 ttu tc mh2 mw-696">
            Our Mission
          </h3>
          <h4
            className="p-emphasis p-lead-spaced--l grey1 mb0 ttu tc mh2 mw-696"
            dangerouslySetInnerHTML={{ __html: block2.content }}
          />
          <div className="w-100 ph2 ph0-l mw-1060 flex flex-column flex-row-l items-center justify-between-l pt2-l">
            <PageQueryAbstractPhoto page={ourEvents} />
            <PageQueryAbstractPhoto
              page={ourServices}
              className="mt1 mt0-l"
            />
            {/* <PageQueryAbstractPhoto page={aboutUs} className="mt1 mt0-l" /> */}
            <Link
              to="/live-downtown/virtual-tour/"
              className="abstract-photo-query mt1 mt0-l db flex flex-column w-100 justify-end bg-blue relative"
            >
              <Imgix
                type="img"
                src={VirtualTourAbstract}
                className="abstract-photo-query__photo absolute top-0 left-0 mb0 image-cover w-100 h-100"
                imgixParams={{
                  'max-w': 2732,
                  'fp-x': page.abstractPhotoFocalPointX,
                  'fp-y': page.abstractPhotoFocalPointY,
                  auto: ['compress'],
                  fit: 'crop',
                  crop: 'focalpoint'
                }}
                htmlAttributes={{
                  alt: 'Virtual Tour'
                }}
              />
              <div className="abstract-photo-query__title bg-white flex items-center center-text justify-center">
                <h4 className="p-emphasis dark mb0 ttu">Virtual Tour</h4>
              </div>
            </Link>
          </div>
        </div>
        {/* This is the Event Query - pulls the most recent event that is also tagged VR */}
        <FeedQueryDown
          page={mostRecentVentureEvent}
          className="mv3 mv5-l"
          secondaryLink={featuredEventsPage}
        />
        <FooterMap
          address="Brown's Island Richmond, VA 23219"
          text="The Downtown Map"
          text2="LEARN EVEN MORE ABOUT WHERE TO GO AND WHAT TO DO DOWNTOWN!"
        />
      </div>
    </div>
  );
};

export default Home;

export const pageQuery = graphql`
  query Home($id: String!) {
    mortyPage(id: { eq: $id }) {
      title
      route
      metaTitle
      section
      metaDescription
      metaKeywords
      bannerImageAltText
      abstractPhotoAltText
      bannerImageFocalPointX
      bannerImageFocalPointY
      abstractPhotoFocalPointX
      abstractPhotoFocalPointY
      bannerImage {
        url
      }
      childrenMortyBlock {
        id
        blockType
        content
        headline
        subheadline
        buttonUrl
        buttonTitle
        format
        caption
        subcaption
        url
        attribution
        focalPointX
        focalPointY
        altText
        attributionAltText
        attributionPhoto {
          url
        }
        image {
          url
        }
        videoType
        videoMinutes
        embedCode
        attribution
        attributionPhoto {
          url
        }
        vistityUrl
        vistityTitle
      }
    }
    allMortyStory {
      edges {
        node {
          id
          title
          route
          abstractPhotoAltText
          abstractPhotoFocalPointX
          abstractPhotoFocalPointY
          abstractPhoto {
            url
          }
          publishedDate
        }
      }
    }
    canalCruises: allMortyPage(
      filter: { route: { eq: "/our-services/riverfront-canal-cruises/" } }
    ) {
      edges {
        node {
          id
          title
          route
          bannerImageAltText
          bannerImageFocalPointX
          bannerImageFocalPointY
          bannerImage {
            url
          }
        }
      }
    }
    featuredEventsPage: allMortyPage(
      filter: { route: { eq: "/our-events/featured-events/" } }
    ) {
      edges {
        node {
          id
          title
          route
        }
      }
    }
    exploreDowntown: allMortyPage(
      filter: { route: { eq: "/explore-downtown/" } }
    ) {
      edges {
        node {
          id
          title
          route
          abstract
        }
      }
    }
    liveDowntown: allMortyPage(filter: { route: { eq: "/live-downtown/" } }) {
      edges {
        node {
          id
          title
          abstract
          route
        }
      }
    }
    workDowntown: allMortyPage(filter: { route: { eq: "/work-downtown/" } }) {
      edges {
        node {
          id
          title
          abstract
          route
        }
      }
    }
    ventureEvents: allMortyEvent(filter: { tags: { eq: "Venture Richmond" } }) {
      edges {
        node {
          id
          title
          route
          eventDate
          endDate
          startTime
          abstractPhotoAltText
          abstractPhotoFocalPointX
          abstractPhotoFocalPointY
          abstractPhoto {
            url
          }
        }
      }
    }
    ourEvents: allMortyPage(filter: { route: { eq: "/our-events/" } }) {
      edges {
        node {
          id
          title
          abstractPhotoAltText
          abstractPhotoFocalPointX
          abstractPhotoFocalPointY
          abstractPhoto {
            url
          }
          route
        }
      }
    }
    ourServices: allMortyPage(filter: { route: { eq: "/our-services/" } }) {
      edges {
        node {
          id
          title
          abstractPhotoAltText
          abstractPhotoFocalPointX
          abstractPhotoFocalPointY
          abstractPhoto {
            url
          }
          route
        }
      }
    }
    aboutUs: allMortyPage(filter: { route: { eq: "/about-us/" } }) {
      edges {
        node {
          id
          title
          abstractPhotoAltText
          abstractPhotoFocalPointX
          abstractPhotoFocalPointY
          abstractPhoto {
            url
          }
          route
        }
      }
    }
    allNews: allMortyStory(filter: { route: { ne: "/dummy-story" } }) {
      edges {
        node {
          id
          title
          route
          publishedDate
          abstractPhotoAltText
          abstractPhotoFocalPointX
          abstractPhotoFocalPointY
          abstractPhoto {
            url
          }
        }
      }
    }
    news: allMortyPage(filter: { route: { eq: "/news/" } }) {
      edges {
        node {
          id
          title
          route
        }
      }
    }
  }
`;

export const previewQuery = `
  query Home($id: String!) {
    mortyPage(id: { eq: $id }) {
      title
      route
      metaTitle
      metaDescription
      metaKeywords
      bannerImageAltText
      abstractPhotoAltText
      bannerImageFocalPointX
      bannerImageFocalPointY
      abstractPhotoFocalPointX
      abstractPhotoFocalPointY
      bannerImage {
        url
      }
      childrenMortyBlock {
        id
        blockType
        content
        headline
        subheadline
        buttonUrl
        buttonTitle
        format
        caption
        subcaption
        url
        attribution
        focalPointX
        focalPointY
        altText
        attributionAltText
        attributionPhoto {
          url
        }
        image {
          url
        }
        videoType
        videoMinutes
        embedCode
        attribution
        attributionPhoto {
          url
        }
        vistityUrl
        vistityTitle
      }
    }
    allMortyStory {
      edges {
        node {
          id
          title
          route
          abstractPhotoAltText
          abstractPhotoFocalPointX
          abstractPhotoFocalPointY
          abstractPhoto {
            url
          }
          publishedDate
        }
      }
    }
    canalCruises: allMortyPage(
      filter: { route: { eq: "/our-services/riverfront-canal-cruises/" } }
    ) {
      edges {
        node {
          id
          title
          route
          bannerImageAltText
          bannerImageFocalPointX
          bannerImageFocalPointY
          bannerImage {
            url
          }
        }
      }
    }
    featuredEventsPage: allMortyPage(
      filter: { route: { eq: "/our-events/featured-events/" } }
    ) {
      edges {
        node {
          id
          title
          route
        }
      }
    }
    exploreDowntown: allMortyPage(
      filter: { route: { eq: "/explore-downtown/" } }
    ) {
      edges {
        node {
          id
          title
          route
          abstract
        }
      }
    }
    liveDowntown: allMortyPage(filter: { route: { eq: "/live-downtown/" } }) {
      edges {
        node {
          id
          title
          abstract
          route
        }
      }
    }
    workDowntown: allMortyPage(filter: { route: { eq: "/work-downtown/" } }) {
      edges {
        node {
          id
          title
          abstract
          route
        }
      }
    }
    ventureEvents: allMortyEvent(filter: { tags: { eq: "Venture Richmond" } }) {
      edges {
        node {
          id
          title
          route
          eventDate
          endDate
          startTime
          abstractPhotoAltText
          abstractPhotoFocalPointX
          abstractPhotoFocalPointY
          abstractPhoto {
            url
          }
        }
      }
    }
    ourEvents: allMortyPage(filter: { route: { eq: "/our-events/" } }) {
      edges {
        node {
          id
          title
          abstractPhotoAltText
          abstractPhotoFocalPointX
          abstractPhotoFocalPointY
          abstractPhoto {
            url
          }
          route
        }
      }
    }
    ourServices: allMortyPage(filter: { route: { eq: "/our-services/" } }) {
      edges {
        node {
          id
          title
          abstractPhotoAltText
          abstractPhotoFocalPointX
          abstractPhotoFocalPointY
          abstractPhoto {
            url
          }
          route
        }
      }
    }
    aboutUs: allMortyPage(filter: { route: { eq: "/about-us/" } }) {
      edges {
        node {
          id
          title
          abstractPhotoAltText
          abstractPhotoFocalPointX
          abstractPhotoFocalPointY
          abstractPhoto {
            url
          }
          route
        }
      }
    }
    allNews: allMortyStory(filter: { route: { ne: "/dummy-story" } }) {
      edges {
        node {
          id
          title
          route
          publishedDate
          abstractPhotoAltText
          abstractPhotoFocalPointX
          abstractPhotoFocalPointY
          abstractPhoto {
            url
          }
        }
      }
    }
    news: allMortyPage(filter: { route: { eq: "/news/" } }) {
      edges {
        node {
          id
          title
          route
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/Home.js